import React from "react";
import { FaEnvelope, FaEnvelopeOpen, FaTrash } from "react-icons/fa";

import {
  formatShortDate,
  getLatestMessages,
  getUnreadMessagesCount,
} from "../utils/adminDashboardUtils";

function AdminMessagesPanel({
  messages = [],
  actionId,
  onToggleRead,
  onDelete,
}) {
  const latestMessages = getLatestMessages(messages, 8);
  const unreadCount = getUnreadMessagesCount(messages);

  return (
    <section className="overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-xl shadow-slate-200/60 dark:border-white/10 dark:bg-slate-900 dark:shadow-black/20">
      <div className="flex flex-col gap-3 border-b border-slate-200 p-5 dark:border-white/10 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.14em] text-sky-700 dark:text-sky-200">
            Formulaire de contact
          </p>

          <h2 className="mt-2 font-titre text-2xl font-bold text-slate-950 dark:text-white">
            Derniers messages
          </h2>
        </div>

        <span className="inline-flex min-h-10 items-center justify-center rounded-2xl bg-sky-100 px-4 py-2 text-xs font-bold text-sky-700 dark:bg-sky-500/10 dark:text-sky-200">
          {unreadCount} non lu{unreadCount > 1 ? "s" : ""}
        </span>
      </div>

      {latestMessages.length > 0 ? (
        <div className="divide-y divide-slate-100 dark:divide-white/10">
          {latestMessages.map((message) => {
            const isUnread = !message.read_message;
            const isWorking = actionId === message.id;

            return (
              <article
                key={message.id}
                className={`grid gap-4 p-4 transition hover:bg-sky-50/60 dark:hover:bg-white/[0.03] lg:grid-cols-[160px_1fr_150px] lg:items-start ${
                  isUnread ? "bg-sky-50/50 dark:bg-sky-500/5" : ""
                }`}
              >
                <div>
                  <p className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400">
                    {formatShortDate(message.created_at)}
                  </p>

                  <div
                    className={`mt-2 inline-flex items-center gap-2 rounded-full px-3 py-1 text-xs font-bold ${
                      isUnread
                        ? "bg-red-100 text-red-700 dark:bg-red-500/10 dark:text-red-200"
                        : "bg-emerald-100 text-emerald-700 dark:bg-emerald-500/10 dark:text-emerald-200"
                    }`}
                  >
                    {isUnread ? <FaEnvelope /> : <FaEnvelopeOpen />}
                    {isUnread ? "Non lu" : "Lu"}
                  </div>
                </div>

                <div className="min-w-0">
                  <p className="font-bold text-slate-950 dark:text-white">
                    {message.name || "Visiteur"}
                  </p>

                  <p className="mt-1 truncate text-xs font-semibold text-slate-400">
                    {message.email || "Email non renseigné"}
                  </p>

                  <p className="mt-3 whitespace-pre-line break-words rounded-2xl bg-slate-50 p-4 text-sm font-medium leading-7 text-slate-600 dark:bg-slate-950 dark:text-white/60">
                    {message.message || "Message vide"}
                  </p>
                </div>

                <div className="grid grid-cols-2 gap-2 lg:grid-cols-1">
                  <button
                    type="button"
                    onClick={() => onToggleRead(message.id)}
                    disabled={isWorking}
                    className="inline-flex min-h-10 items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-3 py-2 text-xs font-bold text-slate-700 transition hover:border-sky-200 hover:text-sky-700 disabled:cursor-not-allowed disabled:opacity-50 dark:border-white/10 dark:bg-white/[0.05] dark:text-white"
                  >
                    {message.read_message ? <FaEnvelope /> : <FaEnvelopeOpen />}
                    {message.read_message ? "Non lu" : "Lu"}
                  </button>

                  <button
                    type="button"
                    onClick={() => onDelete(message.id)}
                    disabled={isWorking}
                    className="inline-flex min-h-10 items-center justify-center gap-2 rounded-2xl bg-red-600 px-3 py-2 text-xs font-bold text-white transition hover:-translate-y-0.5 hover:bg-red-700 disabled:cursor-not-allowed disabled:bg-slate-300 disabled:text-slate-500"
                  >
                    <FaTrash />
                    Suppr.
                  </button>
                </div>
              </article>
            );
          })}
        </div>
      ) : (
        <div className="p-8 text-center text-sm font-bold text-slate-400">
          Aucun message pour le moment.
        </div>
      )}
    </section>
  );
}

export default AdminMessagesPanel;